import type { VehicleNode } from "../types/productTaxonomyApiTypes";

export const findVehiclePath = (
  tree: VehicleNode[],
  id: number | null,
): VehicleNode[] => {
  if (!id) return [];
  for (const node of tree) {
    if (node.id === id) return [node];
    const path = findVehiclePath(node.children, id);
    if (path.length) return [node, ...path];
  }
  return [];
};

// Preserve the model/engine context when a catalogue has more than two levels.
export const getVehicleModelOptions = (
  brand?: VehicleNode,
): { value: number; label: string }[] => {
  const options: { value: number; label: string }[] = [];
  const visit = (nodes: VehicleNode[], prefix: string[]) => {
    for (const node of nodes) {
      const path = [...prefix, node.name];
      options.push({ value: node.id, label: path.join(" / ") });
      visit(node.children, path);
    }
  };
  visit(brand?.children ?? [], []);
  return options;
};
